import axios from 'axios';
import authHeaders from './auth-header';

const IMPORT_PATIENT_FILE_URL = process.env.VUE_APP_BASE_AP_URL+`/technical/patients/import`;
/**
 * Imports a patient file.
 * @param {File} file - The file to be imported.
 * @returns {Promise} - A promise that resolves with the response data or rejects with an error.
 */
export async function importPatientFile(file) {
	const formData = new FormData();
	formData.append('file', file);
	return axios.post(IMPORT_PATIENT_FILE_URL, formData, {headers : { 'Authorization':authHeaders(), 'Content-Type': 'multipart/form-data'}})
	.then(response => {
		if(response.data) {
			return Promise.resolve(response.data);
		}
	})
	.catch(error => {
		return Promise.reject(error);
	});
}